<!-- Header -->
<div class="overview__header">
  <h1 class="overview__title">Projektübersicht</h1>
  <div class="overview__header-actions">
    <button mat-flat-button class="overview__settings-btn">
      <mat-icon>settings</mat-icon>
      Einstellungen
    </button>
    <div class="overview__avatar">
      <mat-icon>person</mat-icon>
    </div>
  </div>
</div>

<!-- Wird erstmal nicht von den Stakeholdern gewünscht. -->

<!-- Widget Row -->
<!--<div class="overview__widgets">-->
<!--  <div class="overview__widget overview__widget&#45;&#45;delay-1">-->
<!--    <app-status-widget [projects]="projects()" />-->
<!--  </div>-->
<!--  <div class="overview__widget overview__widget&#45;&#45;delay-2">-->
<!--    <app-deadline-widget />-->
<!--  </div>-->
<!--  <div class="overview__widget overview__widget&#45;&#45;delay-3 overview__widget&#45;&#45;right-col">-->
<!--    &lt;!&ndash; Top Bar (Settings & Profile already in header, filter below) &ndash;&gt;-->
<!--    <app-filter-widget-->
<!--      [activeFilter]="activeFilter()"-->
<!--      (filterChange)="onFilterChange($event)" />-->
<!--  </div>-->
<!--</div>-->

<!-- Table Section -->
<mat-card class="overview__table-card overview__widget overview__widget--delay-3">
  <mat-card-content>
    <!-- Table Header & Search -->
    <div class="overview__table-header">
      <div class="overview__table-title-group">
        <h2 class="overview__table-title">Aktuelle Projekte</h2>
        <span class="overview__table-count">Insgesamt: {{ allProjects.filteredData.length }}</span>
      </div>
      <mat-form-field class="overview__search-field" appearance="outline">
        <mat-icon matPrefix>search</mat-icon>
        <input matInput placeholder="Suchen..." (keyup)="applySearch($event)" />
      </mat-form-field>
    </div>

    <!-- Data Table -->
    <table mat-table [dataSource]="allProjects" matSort class="overview__table">
      <!-- Projekt-Nr. -->
      <ng-container matColumnDef="contractNr">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Projekt-Nr.</th>
        <td mat-cell *matCellDef="let row">{{ row.contractNr }}</td>
      </ng-container>

      <!-- Projektname -->
      <ng-container matColumnDef="displayName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Projektname</th>
        <td mat-cell *matCellDef="let row">{{ row.displayName }}</td>
      </ng-container>

      <!-- Phase -->
      <ng-container matColumnDef="phase">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Phase</th>
        <td mat-cell *matCellDef="let row">{{ row.phase }}</td>
      </ng-container>

      <!-- Aktion -->
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef class="overview__action-header">Aktion</th>
        <td mat-cell *matCellDef="let row" class="overview__action-cell">
          <button mat-flat-button
                  class="overview__action-btn"
                  [routerLink]="['/qs/project', row.contractNr]">
            Zum Projekt
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      <!-- Empty State -->
      <tr class="mat-row overview__empty-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          Keine Projekte für diesen Filter gefunden.
        </td>
      </tr>
    </table>

    <!-- Footer -->
    <div class="overview__table-footer">
      <span class="overview__entries-badge">Einträge: {{ allProjects.filteredData.length }}</span>
    </div>
  </mat-card-content>
</mat-card>

